const form = {
  form: 'Форма',
  form1: 'Форма 1',
  save: 'Сохранить',
  edit: 'Редактировать',
  cancel: 'Отмена',
  back: 'Назад',
  forward: 'Вперед',
  backToHome: 'Вернуться на главную',
  addFile: 'Добавить файл',
  attachFile: 'Прикрепить файл',
  attachments: 'Приложения',
  unsavedChanges: 'Похоже, вы внесли изменения. Вы хотите их сохранить?',
};

export default form;
